import { isWithinInterval as isWithinIntervalFns } from 'date-fns';
import isEqual from '@teetsh/app/src/utils/time/isEqual';

export default function isWithinInterval(
  date: Date,
  { start, end }: { start: Date; end: Date },
  strict = false,
): boolean {
  if (strict) {
    return (
      isWithinIntervalFns(date, { start, end }) &&
      !isEqual(date, start) &&
      !isEqual(date, end)
    );
  }
  return isWithinIntervalFns(date, { start, end });
}
